import { spacesToDashes } from "../helpers";

/**
 * PDF P-1: categories pages canonical must point to the current city gender page.
 *
 * @param {Object} input
 * @param {string} input.baseUrlApp Public site origin.
 * @param {string} input.cityName Current city title from global state.
 * @param {string} input.gender Route gender param.
 * @return {string}
 */
export function resolveCategoryCanonicalUrl({
  baseUrlApp = "",
  cityName = "",
  gender = "",
} = {}) {
  const baseUrl = baseUrlApp.replace(/\/$/, "");
  const city = spacesToDashes(cityName);

  return `${baseUrl}/${city}/${gender}`;
}
